import { render, staticRenderFns } from "./DashboardOverlay.vue?vue&type=template&id=133bb55d&scoped=true"
import script from "./DashboardOverlay.vue?vue&type=script&lang=js"
export * from "./DashboardOverlay.vue?vue&type=script&lang=js"
import style0 from "./DashboardOverlay.vue?vue&type=style&index=0&id=133bb55d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133bb55d",
  null
  
)

export default component.exports